






























































import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';

@Component({})
export default class ChatUserList extends Vue {
  @Prop({ default: false })
  public isTechnicalSupportChat!: boolean;

  @Prop({ default: false })
  public isAdministratorChat!: boolean;

  @Prop({ default: null })
  public searchId: string | undefined;

  @Prop({ default: null })
  public selectedUserId: string | null = null;

  public userList: Array<any> = [];

  public searchString: string = '';

  get rootId() {
    if (this.searchId === undefined) {
      return 'chat-list';
    }
    return this.searchId;
  }

  public created() {
    if (this.isTechnicalSupportChat) {
      this.$chatHub.$on('ReceiveTechMessage', this.onReceiveTechMessage);
    } else if (this.isAdministratorChat) {
      this.$chatHub.$on('ReceiveAdministratorMessage', this.onReceiveAdministratorMessage);
    } else {
      this.$chatHub.$on('ReceiveMessage', this.onReceiveMessage);
    }
    this.$chatHub.$on('LoadMessages', this.onLoadMessages);

    let getUsersUrlPart = this.isTechnicalSupportChat ? 'GetTechChatUserList' : 'GetChatUserList';
    if(this.isAdministratorChat) {
      getUsersUrlPart = 'GetAdministratorChatUserList';
    }

    axios
      .get(`/Users/${getUsersUrlPart}`)
      .then((response) => {
        this.userList = response.data;
        this.sortUserList();
      });
  }

  sortUserList() {
    this.userList = this.userList.sort(function(a, b) {
      return (
        (b.unreadMessagesCount > 0 &&
          new Date(b.lastSendDate).getTime() -
            new Date(a.lastSendDate).getTime()) ||
        new Date(b.lastSendDate).getTime() -
          new Date(a.lastSendDate).getTime() ||
        (a.login === b.login ? 0 : a.login < b.login ? -1 : 1)
      );
    });
  }

  beforeDestroy() {
    if (this.isTechnicalSupportChat) {
      this.$chatHub.$off('ReceiveTechMessage', this.onReceiveTechMessage);
    } else if (this.isAdministratorChat) {
      this.$chatHub.$on('ReceiveAdministratorMessage', this.onReceiveAdministratorMessage);
    } else {
      this.$chatHub.$off('ReceiveMessage', this.onReceiveMessage);
    }
    this.$chatHub.$off('LoadMessages', this.onLoadMessages);
  }

  private onReceiveTechOrAdministratorMessage(message: any, userUrl: string)
  {
    if (message.toUserId != this.selectedUserId) {
      this.$store.commit('chat/incrementUnreadMessagesCount');
      var user = this.userList.find((t) => t.id == message.toUserId);
      if (!user) {
        axios
          .get(userUrl, {
            params: {
              userId: message.toUserId,
            },
          })
          .then((response) => {
            user = response.data;
            this.userList.push(user);
            this.sortUserList();
          });
      } else {
        user.unreadMessagesCount++;
        user.lastSendDate = message.dateOfSend;
        this.sortUserList();
      }
    }
  }

  onReceiveTechMessage(message: any) {
    this.onReceiveTechOrAdministratorMessage(message, '/Users/GetTechChatUser');
  }

  onReceiveAdministratorMessage(message: any) {
    this.onReceiveTechOrAdministratorMessage(message, '/Users/GetAdministratorChatUser');
  }

  onReceiveMessage(message: any) {
    if (
      message.fromUserId != this.selectedUserId &&
      message.toUserId == this.currentUserId
    ) {
      this.$store.commit('chat/incrementUnreadMessagesCount');
      var user = this.userList.find((t) => t.id == message.fromUserId);
      user.unreadMessagesCount++;
      user.lastSendDate = message.dateOfSend;
      this.sortUserList();
    }
  }

  onLoadMessages() {
    const user = this.userList.find((t) => t.id == this.selectedUserId);

    if (user) {
      this.$store.commit(
        'chat/reduceUnreadMessagesCount',
        user.unreadMessagesCount
      );
      user.unreadMessagesCount = 0;
    }
  }

  get title() {
    if(this.isTechnicalSupportChat)
    {
      return this.$t('Техподдержке');
    }
    if(this.isAdministratorChat)
    {
      return this.$t('Администраторам');
    }

    return this.$t('Сотрудники');
  }

  get currentUserId() {
    return this.$auth.user().id;
  }
}
